export enum AccessType {
    Project,
    Section,
    Resource
}

export enum AccessLevel {
    Viewer,
    Editor
}